import { getBatchFileName } from 'commons/utils'
import { Request } from 'commons/utils/request'
import { TableButton } from 'ui/components/Buttons'
import { DateTime } from 'ui/components/DateTime'
import { DownloadLink } from 'ui/components/DownloadLink'
import { TableColumn, TableColumnAlign } from 'ui/components/Table'
import { Toast } from 'ui/components/Toast'

import { HRRFile } from '../../types'

const handleError = (message: string) => Toast.error('Error', message)
const baseUrl = Request.urls.bank.reportFileDownload

export const columns = (onDelete: (fileName: string, id: number) => void): TableColumn<HRRFile>[] => [
  {
    title: 'File Name',
    align: TableColumnAlign.LEFT,
    render: ({ fileName, id }) => {
      const name = fileName && getBatchFileName(fileName)

      return (
        <DownloadLink
          direct
          parametersForm={{ reportFileId: id, attachment: true }}
          baseUrl={baseUrl}
          name={name}
          handleError={handleError}
          method="put"
        >
          {name}
        </DownloadLink>
      )
    }
  },
  {
    title: 'Uploaded Date',
    align: TableColumnAlign.LEFT,
    render: ({ uploadedDate }) => <DateTime date={uploadedDate} withTime />
  },
  {
    title: 'Action(s)',
    align: TableColumnAlign.RIGHT,
    render: ({ enableDelete, id, fileName }) => {
      const name = fileName && getBatchFileName(fileName)

      return (
        enableDelete && (
          <TableButton face="neutral" onClick={() => onDelete(name, id)}>
            Delete
          </TableButton>
        )
      )
    }
  }
]
